module.exports = __webpack_public_path__ + "static/img/news2.ae46b84.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/mobile_img/news2.png
// module id = j1tC
// module chunks = 7